import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormControl, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { NgToastService } from 'ng-angular-popup';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { OrganizationService } from '@/app/services/organization/organization.service';
import { Subscription } from 'rxjs';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { PqqSectionsComponent } from '../pqq-sections.component';
import { MatIcon } from '@angular/material/icon';
@Component({
  selector: 'app-select-companies',
  standalone: true,
  imports: [
    MatChipsModule,
    MatButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIcon,
  ],
  templateUrl: './select-companies.component.html',
  styleUrl: './select-companies.component.css',
})
export class SelectCompaniesComponent implements OnInit {
  private subscription: Subscription = new Subscription();
  organizationDetail: any;
  projectName: string;
  submittedInitiation: any;
  enrichedOrganizations: any;
  ngOnInit(): void {
    this.projectName = localStorage.getItem('project-name');
    // this.setupValidators();
    this.fetchOrganization();
    this.subscription = this.GetProjectIdService.projectId$.subscribe((id) => {
      this.projectIdNew = id;
      if (!this.projectIdNew) {
        this.projectIdNew = this.GetProjectIdService.getProjectId();
      }
    });
    this.submittedInitiationData();
  }

  projectIdNew: string;
  constructor(
    private toast: NgToastService,
    private OrganizationService: OrganizationService,
    private GetProjectIdService: GetProjectIdService,
    private PqqSectionsComponent: PqqSectionsComponent,
    private projectsService: ProjectsService,
    private TenderingService: TenderingService
  ) {}
  searchTerm = '';
  filteredOrganizations: any[] = [];
  other = false;

  organizationControl = new FormControl();
  company_name = new FormControl();
  name = new FormControl('', Validators.required);
  position = new FormControl('', Validators.required);
  email = new FormControl('', Validators.required);
  organizations: any;
  selectedOrganizations: any;
  organizationDetails: any[] = []; // Array to store the organization details

  otherSelection() {
    this.other = true;
    this.company_name.setValue('');
    this.name.setValue('');
    this.email.setValue('');
    this.position.setValue('');
    this.company_name.setValidators([Validators.required]);
  }

  addOrganizationDetail() {
    
    this.name.markAsTouched();
    this.email.markAsTouched();
    this.position.markAsTouched();
    this.organizationControl.markAsTouched();
    if(this.other){
      this.company_name.markAsTouched();
    }



    // Validation check
    if (
      (!this.selectedOrganizations && !this.company_name.value) || // At least one should be present
      !this.name.value ||
      !this.email.value ||
      !this.position.value
    ) {
      this.toast.danger('Please fill the required fields', 'ERROR');
      return;
    }

    // If validation passes, create the object
    const organizationDetail = {
      company_name: this.selectedOrganizations?.name
        ? this.selectedOrganizations?.name
        : this.company_name.value || null,
      name: this.name.value,
      email: this.email.value,
      position: this.position.value,
      id: this.selectedOrganizations?.id || null,
      type: this.selectedOrganizations?.id ? 'system' : 'external',
    };

    this.organizationDetails.push(organizationDetail); // Add the object to the array

    this.toast.success('Organization added', 'success');
    // Clear fields and reset the form controls
    this.organizationControl.reset();
    this.company_name.reset();
    this.name.reset();
    this.email.reset();
    this.position.reset();
    this.selectedOrganizations = null; // Reset the selected organization
    this.other = false; // Reset 'other' selection
  }

  addOrganization() {
    const org = this.organizationControl.value;

    this.selectedOrganizations = org;
  }

  fetchOrganization() {
    this.OrganizationService.getAllOrganization().subscribe({
      next: (response: any) => {
        this.organizations = response.data;
        this.filteredOrganizations = [...this.organizations];
      },
      error: (error: any) => {
        this.toast.danger(error);
      },
    });
  }

  prepareData(org: any) {
    const data = {
      id: org?.id ? org?.id : '',
      name: this.company_name.value ? this.company_name.value : '',
    };
    return data;
  }

  DetailOrganizations(org: any) {
    if (org?.id) {
      this.other = false;
      this.company_name.setValue('');
    }

    const dataToSubmit = this.prepareData(org);

    this.OrganizationService.getDetailOrganizationsPqq(dataToSubmit).subscribe({
      next: (response: any) => {
        if (response?.data) {
          this.organizationDetail = response.data;

          this.name.setValue(response.data.name || '');
          this.email.setValue(response.data.email || '');
          this.position.setValue(response.data.position || '');
        } else {
          // If no data, clear form controls
          this.organizationDetail = null;
          this.name.setValue('');
          this.email.setValue('');
          this.position.setValue('');
        }
      },
      error: (error: any) => {
        console.error('API Error:', error);

        // Handle error case: clear organization details and form controls
        this.organizationDetail = null;
        this.name.setValue('');
        this.email.setValue('');
        this.position.setValue('');
      },
    });
  }

  removeOrganization(org: string) {
    const index = this.organizationDetails.indexOf(org);
    if (index >= 0) {
      this.organizationDetails.splice(index, 1);
    }
  }

  filterOrganizations() {
    const search = this.searchTerm.toLowerCase();
    this.filteredOrganizations = this.organizations.filter(
      (org: any) => org.name.toLowerCase().includes(search) // Adjust field access based on your API response
    );
  }

  moveToPreviousStep() {
    this.PqqSectionsComponent.previousStep();
  }

  prepareDataToSubmit() {
    const data = {
      receiving_org_data: this.organizationDetails,
    };

    return data;
  }

  submittedInitiationData(): any {
    return this.projectsService.getSubmittedInitiationDataPQQ().subscribe({
      next: (response: any) => {
        this.submittedInitiation = response?.data?.selected_organizations;
        const data = response?.data?.selected_organizations;
        data?.forEach((org: any) => {
          const singleOrg = {
            company_name: org?.receiving_org_id
              ? org?.applicant_organization?.name
              : org?.external_company_name,
            name: org?.name,
            email: org?.email,
            position: org?.position,
            id: org?.receiving_org_id || null,
            type: org?.receiving_org_id ? 'system' : 'external',
          };
          this.organizationDetails.push(singleOrg);
        });
      },
      error: (error) => {
        console.error('Error fetching projects:', error);
      },
    });
  }

  moveToNextStep() {
    const dataToSubmit = this.prepareDataToSubmit();

    this.TenderingService.projectPQQInitiateStep1(dataToSubmit).subscribe({
      next: () => {
        this.toast.success('Companies selection completed', 'SUCCESS');
        this.PqqSectionsComponent.nextStep();
      },
      error: (error: any) => {
        console.error('Failed to submit:', error);
        this.toast.danger(error.error.message, 'DANGER', 4000);
      },
    });
  }
  handleBack() {
    this.PqqSectionsComponent.previousStep();
  }
}
